import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import ActionButton from '@/components/action_button/Index.vue';
import BaseCsvExporter from '@/components/v2/BaseCsvExporter.vue';
import CustomerSegmentExport from '@/components/v2/CustomerSegmentExport';
let CustomerSegmentExportManager = class CustomerSegmentExportManager extends Mixins(ViewportSizeMixin, AlertMixin) {
    get labels() {
        const labels = {
            id: 'ID',
            name: 'Full Name',
            platformOrigin: 'Platform Origin',
            profilePic: 'Profile Picture',
            segmentName: 'Segmentation Name',
        };
        return labels;
    }
    get fields() {
        return Object.keys(this.labels);
    }
    get fileName() {
        const name = this.segmentationName.toLowerCase().replace(' ', '_');
        return name;
    }
    get csvName() {
        const timestamp = moment().unix();
        return `${timestamp}_${this.fileName}`;
    }
    alertError(data) {
        if (!data || data.length === 0) {
            this.errorNotification('No data to export');
        }
    }
};
__decorate([
    Prop({ type: String, required: true })
], CustomerSegmentExportManager.prototype, "appUuid", void 0);
__decorate([
    Prop({ type: String, required: true })
], CustomerSegmentExportManager.prototype, "appSegmentationUuid", void 0);
__decorate([
    Prop({ type: String, required: true })
], CustomerSegmentExportManager.prototype, "segmentationName", void 0);
CustomerSegmentExportManager = __decorate([
    Component({
        components: {
            BaseCsvExporter,
            ActionButton,
            CustomerSegmentExport,
        },
    })
], CustomerSegmentExportManager);
export default CustomerSegmentExportManager;
